module.exports = __webpack_public_path__ + "static/assets/5c293dc70cee7ce34f53ca9bc9bf01b5.gif";